// This file can be replaced during build by using the `fileReplacements` array.
// `ng build --prod` replaces `environment.ts` with `environment.prod.ts`.
// The list of file replacements can be found in `angular.json`.

export const environment = {
  production: false,
  firebase: {
    apiKey: "AIzaSyDzcjs4wCmwa_tj4tz1i0Rp9ZW-T9GbjS4",
    authDomain: "squares-38509.firebaseapp.com",
    databaseURL: "https://squares-38509.firebaseio.com",
    projectId: "squares-38509",
    storageBucket: "squares-38509.appspot.com",
    messagingSenderId: "471913894299",
    appId: "1:471913894299:web:93a2cf254c9819ab58d13e",
    measurementId: "G-XF4EDF57ZP"
  }
};
/*
 * For easier debugging in development mode, you can import the following file
 * to ignore zone related error stack frames such as `zone.run`, `zoneDelegate.invokeTask`.
 *
 * This import should be commented out in production mode because it will have a negative impact
 * on performance if an error is thrown.
 */
// import 'zone.js/dist/zone-error';  // Included with Angular CLI.
